// Import Dateependencies
import React from "react";
import ReactDOM from "react-dom";
import { CustomThemeProvider } from "themeProvider";
import registerServiceWorker from "registerServiceWorker";
import 'intl';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/fr';
import 'intl/locale-data/jsonp/de';
import 'intl/locale-data/jsonp/ja';


// Import components
import App from "App";
import theme from "styles/theme";


// Render App
ReactDOM.render(
    <CustomThemeProvider theme={theme}>
        <App />
    </CustomThemeProvider>,
  document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js